import AppRoutes from "./AppRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { initializeFacebookPixel } from './utils/facebookPixel';
import { ThemeProvider } from './styles/ThemeProvider';
import regionConfig from './config/regionConfig';

function App() {
  // Inicializa o Facebook Pixel apenas uma vez
  useEffect(() => {
    initializeFacebookPixel();
  }, []);

  // Set document title based on brand
  useEffect(() => {
    document.title = regionConfig.brand.name;
  }, []);

  return (
    <ThemeProvider>
      <div translate="no" className='app'>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          limit={5}
        />
        <AppRoutes />
      </div>
    </ThemeProvider>
  );
}

export default App;
